export const BASE_DESIGN_WIDTH = 373;
export const BASE_DESIGN_HEIGHT = 382;

export const PIE_COLORS = [
	'var(--chart-accent-1)',
	'var(--chart-accent-2)',
	'var(--chart-accent-3)',
] as const;

export const CHART_ITEM_COLORS: Record<string, string> = {
	solo: 'var(--chart-donut-dark)',
	foliar: 'var(--chart-donut-medium)',
	agua: 'var(--chart-donut-light)',
	agricultores: 'var(--chart-donut-dark)',
	consultores: 'var(--chart-donut-medium)',
	inativos: 'var(--chart-donut-light)',
	geradas: 'var(--chart-donut-dark)',
	'em implementacao': 'var(--chart-donut-medium)',
	implementadas: 'var(--chart-donut-medium)',
	concluidas: 'var(--chart-donut-light)',
	pendentes: 'var(--chart-donut-light)',
	'em andamento': 'var(--chart-donut-medium)',
} as const;

export const PIE_CONFIG = {
	outerRadius: '90%',
	innerRadius: '0%',
	paddingAngle: 2,
	startAngle: 90,
	endAngle: -270,
	minPercentForLabel: 0.05,
} as const;

export const LABEL_CONFIG = {
	fontSize: '13',
	fontWeight: '600',
	fontFamily: 'var(--font-poppins)',
	fill: 'white',
} as const;
